import { Link } from "wouter";
import { WidgetPanel } from "@/components/dashboard-grid/WidgetPanel";
import { PROSPECT_STAGES } from "@shared/prospectConstants";
import type { OriginationPayload } from "@shared/dashboardOrigination";
import { HBars } from "./HBars";

/** Prospects per stage as a centered funnel. Counts only, so it is ungated. */
export function ProspectFunnel({ o }: { o: OriginationPayload }) {
  const f = o.funnel;
  const total = f.noStage + PROSPECT_STAGES.reduce((s, st) => s + (f.byStage[st] ?? 0), 0);
  return (
    <WidgetPanel title="Prospect funnel" meta={`${total} by stage`} action={<Link href="/prospects" className="text-xs font-medium text-primary-text hover:underline">Board</Link>}>
      <HBars
        centered
        rows={[{ label: "No stage yet", value: f.noStage, muted: true }, ...PROSPECT_STAGES.map((s) => ({ label: s, value: f.byStage[s] ?? 0 }))]}
        footer={`${f.parked} parked (on hold) · ${o.tiles.newProspects30d} new in the last 30 days`}
      />
    </WidgetPanel>
  );
}
